export const HotDeals = 'H';
export const ReadyToBuild = 'R';
export const Model = 'M';
export const AvailableNow = 'A';
export const UnderConstruction = 'UC';